import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/vilicvane/projects/makeflow/boring-router/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "get-started"
    }}>{`Get Started`}</h1>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# Install dependencies if you haven't
yarn add react react-dom mobx mobx-react-lite

# Install Boring Router packages
yarn add boring-router boring-router-react
`}</code></pre>
    <h2 {...{
      "id": "setup-a-router"
    }}>{`Setup a router`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import {Router} from 'boring-router';
import {BrowserHistory} from 'boring-router-react';

const history = new BrowserHistory();

const router = new Router(history);
`}</code></pre>
    <h2 {...{
      "id": "create-primary-route"
    }}>{`Create primary route`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const route = router.$route({
  $children: {
    // Match \`/workbench\`.
    workbench: true,
    // Match \`/user-settings\`.
    userSettings: true,
    // Match the rest.
    notFound: {
      $match: /.*/,
    },
  },
});
`}</code></pre>
    <h2 {...{
      "id": "add-some-route-components"
    }}>{`Add some route components`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import {Route, Link} from 'boring-router-react';
import {observer} from 'mobx-react-lite';
import React from 'react';
import ReactDOM from 'react-dom';

const App = observer(() => {
  return (
    <>
      <ul>
        <li>
          <Link to={route}>Home</Link>
        </li>
        <li>
          <Link to={route.workbench}>Workbench</Link>
        </li>
        <li>
          <Link to={route.userSettings}>User Settings</Link>
        </li>
      </ul>
      <hr />
      <Route exact match={route} component={HomeView} />
      <Route match={route.workbench} component={WorkbenchView} />
      <Route match={route.userSettings} component={UserSettingsView} />
      <Route match={route.notFound} component={NotFoundView} />
    </>
  );
});

ReactDOM.render(<App />, document.getElementById('app'));
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      